// extracted by mini-css-extract-plugin
module.exports = {"parent":"Wrapper_parent__6PaRD"};